import Image from 'next/image'

const FACTOR = 1.5

interface IImage {
  width: number
  className?: string
}

const Blancos = ({ className, width }: IImage) => (
  <Image
    alt="powered by unholster"
    className={className}
    height={width / FACTOR}
    priority
    src="/icons/blancos.svg"
    width={width}
  />
)

export default Blancos
